module.exports = __webpack_public_path__ + "img/area.7ae1ee9b.png";